export const PRODUCTS_LIST_STATE_KEY = "admin_products_list_state";

export const getProductsListStateKey = (userId) => `${PRODUCTS_LIST_STATE_KEY}_${userId || "guest"}`;

export const clearProductsListStateStorage = () => {
  try {
    localStorage.removeItem(PRODUCTS_LIST_STATE_KEY);
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(`${PRODUCTS_LIST_STATE_KEY}_`)) {
        localStorage.removeItem(key);
      }
    });
  } catch {
    // Ignore storage access errors.
  }
};
